import { Outlet } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useMemo } from "react";
import { useI18n } from "../../i18n";
import { ComplianceCenterNavTabs } from "../../components/compliance-center/ComplianceCenterNavTabs";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import layoutStyles from "../../styles/layouts/PageLayout.module.scss";
import { featureFlags } from "../../config/featureFlags";
import { ComplianceExecutionProvider } from "../../context/ComplianceExecutionContext";
import { buildComplianceCenterNavSections } from "./complianceCenterNavConfig";

export default function ComplianceCenterLayout() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const sections = useMemo(() => buildComplianceCenterNavSections(t), [t]);
  const content = (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className={layoutStyles.titleRow}>
          <div className={layoutStyles.titleColumn}>
            <h1 className="text-xl font-semibold text-textMain">{t("complianceCenterUi.title", "Compliance Center")}</h1>
            <p className="text-sm text-gray-600 mt-1">{t("complianceCenterUi.subtitle", "Unified operating console for compliance and audit readiness.")}</p>
          </div>
          <div className={layoutStyles.primaryActions}>
            <Button
              type="button"
              data-testid="compliance-back-dashboard-button"
              color="outline"
              size="medium"
              icon={<ArrowLeft className={layoutStyles.headerIcon} aria-hidden />}
              onClick={() => navigate("/")}
              className={layoutStyles.backButton}
            >
              {t("reports.backToDashboard", "Back to Dashboard")}
            </Button>
          </div>
        </div>
      </div>
      <ComplianceCenterNavTabs
        sections={sections}
        variant={featureFlags.ENTERPRISE_OPERATIONAL_UX_V1 ? "enterprise" : "default"}
      />
      <Outlet />
    </div>
  );

  if (featureFlags.COMPLIANCE_EXECUTION_ORCHESTRATION_V1) {
    return <ComplianceExecutionProvider>{content}</ComplianceExecutionProvider>;
  }
  return content;
}
